import { render } from "./SubscribeView.vue?vue&type=template&id=55214bc0"
import script from "./SubscribeView.vue?vue&type=script&lang=js"
export * from "./SubscribeView.vue?vue&type=script&lang=js"

import "./SubscribeView.vue?vue&type=style&index=0&id=55214bc0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__